import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessState } from '@state/business';
import { filter, switchMap, tap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const DocumentRequestsGuard: CanMatchFn = (): Observable<boolean> => {
	const navService = inject(NavigationService);
	const store = inject(Store);

	return store.select(BusinessState.getLoaded).pipe(
		filter((loaded) => loaded),
		switchMap(() => store.select(BusinessState.isDocumentRequestsEnabled)),
		switchMap((isDocumentRequestsEnabled) =>
			store.select(BusinessState.isFullyOnWord).pipe(
				map((isFullyOnWord) => ({
					isDocumentRequestsEnabled,
					isFullyOnWord,
				})),
			),
		),
		tap(({ isDocumentRequestsEnabled, isFullyOnWord }) => {
			if (!(isDocumentRequestsEnabled || isFullyOnWord)) {
				navService.goToDashboard();
			}
		}),
		map(
			({ isDocumentRequestsEnabled, isFullyOnWord }) =>
				isDocumentRequestsEnabled || isFullyOnWord,
		),
	);
};
